import {lifecycle} from 'recompose';

export default lifecycle({

    componentDidUpdate() {
    },

    componentDidMount() {
        // Load CareUnits for dropdown (filtered by role on backend)
        this.props.listCareUnits();
        this.props.listOpticians();
    }

});